module.exports = __webpack_public_path__ + "static/timeseries-b8e6440647bc02f147803fdaa9de20a8.png";